import { apiGet, apiToken } from "./requests";

/*export const getProducts = (data = null) => {
  let path = "products";
  return apiGet(path);
};*/

export const getClients = (params = null) => {
  let path = "customers";
  return apiGet(path, params);
};

export const getCustomer = (id = null) => {
  let path = "customer/" + id;
  return apiGet(path, null);
};

export const getClient = (corporationId = null) => {
  let path = "owner/" + corporationId;
  return apiGet(path);
};

export const newUser = (data) => {
  let path = "newUser";
  return apiToken(data, path);
};

export const editOwner = (data, corporationId = null) => {
  let path = "editOwner/" + corporationId;
  return apiToken(data, path);
};

export const platforms = (data, platformId = null) => {
  let path = "platforms/" + platformId;
  return apiToken(data, path);
};
